import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      // Redirect any old trafic to the correct route
      path: "/guestbook/:hotel/:guestid?/:type?",
      redirect: {
        name: "guestbook main"
      }
    },
    {
      path: "/preview/:hotel/:guestPhase?",
      name: "guestbook preview",
      component: () => import("../views/GuestbookPreview.vue"),
    },
    {
      path: "/mobile/:hotel/:guestPhase?",
      name: "guestbook mobile",
      component: () => import("../views/GuestbookMain.vue"),
    },
    {
      path: "/direct/:hotel/:name?",
      name: "guestbook direct main",
      component: () => import("../views/GuestbookMain.vue"),
    },
    {
      path: "/pages/:hotel/:pageId",
      name: "guestbook page",
      component: () => import("../views/GuestbookPages.vue"),
    },
    {
      path: "/:hotel/:guestid?/:type?",
      name: "guestbook main",
      component: () => import("../views/GuestbookMain.vue"),
    },
  ],
  scrollBehavior(to) {
    if (to.name === "guestbook page") {
      return { x: 0, y: 0 };
    }
  },
});
